import { render } from "./ClusterPermissionsEditor.vue?vue&type=template&id=15d32c8a&scoped=true"
import script from "./ClusterPermissionsEditor.vue?vue&type=script&lang=js"
export * from "./ClusterPermissionsEditor.vue?vue&type=script&lang=js"

import "./ClusterPermissionsEditor.vue?vue&type=style&index=0&id=15d32c8a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15d32c8a"]])

export default __exports__